// extracted by mini-css-extract-plugin
export default {"root":"InvoiceActions_root__S6EEg"};